export default "__VITE_ASSET__sEN0UH5i__$_?react__"